/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = CreateEnquiry
 *
 * 2 = GetEnquiry
 *
 * 3 = GetQuestions
 *
 * 4 = UpdateQuestions
 *
 * 5 = GetRecoms
 *
 * 6 = UpdateRecoms
 *
 * 7 = SendSms
 *
 * 8 = ConfirmSms
 *
 * 9 = UpdateHandover
 *
 * 10 = GetHandover
 *
 * 11 = GetUserStatus
 */
export enum AutomotiveRequestMethod {
  CreateEnquiry = 1,
  GetEnquiry = 2,
  GetQuestions = 3,
  UpdateQuestions = 4,
  GetRecoms = 5,
  UpdateRecoms = 6,
  SendSms = 7,
  ConfirmSms = 8,
  UpdateHandover = 9,
  GetHandover = 10,
  GetUserStatus = 11,
}
